import { DataTable, TableProvider } from "@xest-ui/data-table";
import MyPaginator from "components/PaginatedTable/MyPaginator";
import { DefaultTableComponents } from "components/PaginatedTable/DefaultTableComponents";
import { useHistory, useLocation } from "react-router-dom";
import updateQueryParams from "components/PaginatedTable/updateQueryParams";
import React from "react";
import getSiemensRegistrations from "services/getSiemensRegistrations";

const SiemensUsersTable = ({ organizationId }) => {
  const history = useHistory();
  const location = useLocation();

  const cols = [
    {
      dataIndex: "first_name",
      title: "First Name",
      filterType: {
        dbCol: "users.first_name",
        type: "string",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "last_name",
      title: "Last Name",
      filterType: {
        dbCol: "users.last_name",
        type: "string",
      },
    },
    {
      dataIndex: "email",
      title: "Email",
      filterType: {
        dbCol: "users.email",
        type: "string",
      },
    },
    {
      dataIndex: "source",
      render(record) {
        return record.source === "siemens-posthub"
          ? "Posthub"
          : record.source === "siemens-marketplace"
          ? "Marketplace"
          : record.source;
      },
      title: "Source",
      filterType: {
        dbCol: "users.source",
        type: "string",
      },
    },
  ];

  return (
    <TableProvider
      params={{
        apiCallFn: async function (queryParams) {
          const res = await getSiemensRegistrations({
            organizationId,
            queryParams,
          });
          return {
            data: res.data,
            total: res.data?.metadata?.total || 0,
          };
        },
        initialPageSize: 10,
        config: {
          tableIdentifier: "get-siemens-users-table",
          updateSearchQueryParams(newParams) {
            updateQueryParams({
              history,
              location,
              newParams,
            });
          },
        },
        initialSortCriteria: "-users.created_at",
        deps: [],
      }}
      components={DefaultTableComponents}
      columns={cols}
    >
      <DataTable pagination={false} />
      <MyPaginator />
    </TableProvider>
  );
};

export default SiemensUsersTable;
